import * as React from 'react';
import * as moment from 'moment';
import numeral from 'numeral';
import ZoneSelect from '../../components/cart/zone-select';
import { sumPrices } from '../../helpers/pricing-helpers';
import { CombineCartViewProps } from '../../components/cart/cart-item';

const CartItemView: React.StatelessComponent<CombineCartViewProps> = props => {

    return (
        <li className="" key={props.itemId}>

            <div className="stack-sm">
                {
                    props.itemTitle ?
                        <div className="flex-between">

                            <p className="large align-self-center">{props.itemTitle}</p>

                            {
                                props.showRemoveButton ?
                                    <button type="button" className="un-button hyperlink" onClick={() => props.removeItem(props.itemIdToRemove)}>
                                        <span>{props.text.removeButtonText}</span>
                                    </button>
                                    : null
                            }
                        </div>
                        : null
                }
                <div className="stack-xs">
                    <p>{props.itemDateString} {props.itemTimeString}</p>
                    <p>{props.itemFacility}</p>
                </div>

            </div>
            {
                props.isUnseated
                    ?
                    <ZoneSelect showPriceTypeError={true} itemId={props.itemId} selectedZone={props.selectedZone} />
                    : null
            }

            {
                props.selectedZoneId < 1 ? null
                    :
                    <div className="space-top-sm">
                        <button type="button" className="un-button hyperlink bold" onClick={() => props.removeZone(props.itemId)}>
                            {props.text.changeZoneButtonText}
                        </button>
                    </div>

            }

            {
                props.itemProcessErrorMessage.length > 0 ?
                    <span className="field-validation-error">{props.itemProcessErrorMessage}</span>
                    : null
            }
        </li>
    );
}

export default CartItemView;